export default {
  account_required: 'Please enter username',
  password_required: 'Please enter password',
  confirm_password_different: 'Confirm Password is not the same as Password',
  min_length: "Must be 8 characters or above",
  alphanumeric_char: "Only alphanumeric character are accepted",
  numeric_char: "Only numeric character are accepted",
  list:{
    0: "Your session has expired, please login again.",
    disconnect: "Please check your connection and try again",
    OK: "Tac Code sent successfully", // for tac code
    ok: "Tac Code sent successfully", // for tac code
    CLOSE: "Your account has been banned for violating test's Fair Gaming Terms",
    close: "Your account has been banned for violating test's Fair Gaming Terms",
    accountIdRequired: 'Please enter username',
    passwordStrengthError: 'Create your own password. Password must be 8-20 characters and a combination of number(s) and letter(s).',
    session_expired : 'Session Expired',
    sessionExpired: 'Session Expired',

    app_id_required: "Application ID is required",
    permission_denied: "Permission denied",
    account_id_required: "Username/Account ID is required",
    verification_code_required: "Verification code is required",
    account_not_exists: "Username/Account does not exist",
    account_inactive: "Username/Account is inactive",
    verify_failed: "Verification process failed",
    parent_account_inactive: "Parent account is inactive",
    transfer_id_required: "Transfer ID is required",
    credit_amount_required: "Credit amount is required",
    duplicate_credit_record: "Duplicated credit record",
    member_wallet_not_exists: "Member wallet does not exist",
    debit_amount_required: "Debit amount is required",
    duplicate_debit_record: "Duplicated debit record",
    insufficient_balance: "Available balance is insufficient",
    result_exists: "Result record has existed",
    debit_record_not_found: "Debit record is not found",
    bank_id_required: "Bank ID is required",
    bank_acc_no_required: "Bank account number is required",
    bank_acc_holder_required: "Bank account holder name is required",
    bank_already_setup: "Bank account has already been setup",
    platform_required: "Platform is required",
    parent_not_exists: "Parent does not exist",
    invalid_password: "Password is invalid",
    invalidPassword: "Password is invalid",
    parent_id_required: "Parent ID is required",
    password_required: "Password is required",
    contact_phone_required: "Contact phone number is required",
    account_exists: "User/Account ID has already existed",
    vip_mode_not_exists: "VIP mode does not exist",
    session_not_exists: "Your session has expired, please login again.",
    ticket_id_required: "Ticket ID is required",
    ref_id_required: "Reference ID is required",
    ticket_not_exists: "Ticket does not exist",
    ticket_processed: "Ticket has already been processed",
    min_deposit_not_met: "Deposit amount must be at least equals to minimum amount",
    ongoing_promotion: "You have an ongoing promotion. Please claim again later",
    invalid_promo_package: "Invalid promotion package",
    promo_min_deposit_not_met: "Deposit amount does not meet promotion minimum",
    claim_promo_only_once_a_day: "Promotion can only be claimed once a day",
    first_deposit_unmet: "Daily first deposit reward has be claimed",
    newbie_unmet: "Newbie deposit reward has been claimed",
    claim_promo_only_once: "Promotion can only be claimed once",
    inner_catch: "Unexpected Error",
    systemError: "System Error",
    deposit_amount_required: "Deposit amount is required",
    target_bank_id_required: "Target bank ID is required",
    target_bank_acc_no_required: "Target bank account number is required",
    target_bank_acc_holder_required: "Target bank account holder name is required",
    deposit_date_required: "Deposit date is required",
    deposit_method_required: "Deposit method is required",
    min_deposit_not_set: "Minimum deposit amount has not been set",
    min_balance_not_set: "Minimum available balance has not been set",
    ibank_account_not_exists: "IBANK88 account does not exist",
    ibank_account_inactive: "IBANK88 account is inactive",
    withdrawal_amount_required: "Withdrawal amount is required",
    min_withdrawal_not_set: "Minimum withdrawal amount has not been set",
    bank_member_not_exists: "Target member bank account not existed",
    promotion_requirement_not_met: "You are still having ongoing promotion",
    invalid_promotion: "Invalid promotion",
    new_password_required: "New password is required",
    multiplier_not_found: "System unable to process your request at the moment, please try again later",
    contact_phone_exists: "This phone has already been registered",
    BLOCK: "Your account has been suspended",
    tac_is_valid: "Your previous tac code still valid",
    tac_expired: "Your tac code has expired. Please request new tac code",
    tacExpired: "Your tac code has expired. Please request new tac code",
    invalid_tac: "Invalid Tac Code",
    invalidTac: "Invalid Tac Code",
    invalidPhone: "Invalid phone number",
    tac_not_validate: "Tac code not validate yet",
    tacCodeRequired: "Please enter Tac Code",
    invalid_referral_code: "Invalid Referral Code",
    exceed_max_withdrawal: "Exceed maximum withdrawal",
    bank_member_inactive: "User Bank is inactive",
    loginFailed: "Fail to login",
    loginSucceed: "Login successfully",
    usernameRequired : "Please enter username",
    passwordRequired : "Please enter password",
    logoutSucceed : "Logout successfully",
    logoutFailed : "Fail to logout",
    requestSucceed: "Request Success",
    requestFailed : "Request failed",
    requestProcessing : "Your request is currently being processed",
    requestDelayed: "Request delay",
    verificationCodeRequired: "Verification TAC Code is required",
    newPasswordRequired: "New Password is required",
    bankIdRequired: "Please select bank",
    bankNameRequired: "Bank Name is required",
    bankAccHolderRequired : "Bank Account Holder's name is required",
    bankAccNoRequired: "Bank Account number is required",
    depositAmountRequired: "Please enter deposit amount",
    dateRequired: "Please choose date",
    bonusIdRequired: "Please choose gift to claim",
    bank_member_exists: "Bank account already registered",
    never_deposited : "You must make at least one deposit before you can transfer money to your friends",
    transferAmountMustGreaterThanEqual5: "Transfer amount must be greater or equal IDR 5",
    invalid_transfer_amount: "Transfer amount must be greater or equal IDR 5",
    // account_not_exists : "account not exists"
    ongoing_promotion : "You are still having ongoing promotion",
    insufficient_balance : "Insufficient Balance",
    insufficientBalance : "Insufficient Balance",
    transfer_success: "Transfer Successfully",
    sender_id_required: "Sender ID required",
    recipient_id_required: "Recipient ID required",
    tac_validated: "TAC Code is validated. Please request again",
    pending_result_in_game: "Pending result in game",
    accountIdOnlyNumber: "Valid phone number only",
    unfinishgamedetected: "Please finish your free game before proceed to this action",
    duplicate_review: "You already submitted review previously",
    exceed_withdrawal_frequency: "You have exceeded the daily withdrawal limit.(5 times per day)",
    requestTooFrequentAtLeast2Minutes: "Your request is being processed",
    invalidPhoneNumberFormat: "Invalid Phone Number Format",
    fpayUnderMaintenance: "System under maintenance",
    affiliate_not_exists: "Affiliate not exist",
    phoneRequired: 'Please enter phone number',
    couponeCodeRequired: "Coupon code is required",
    coupon_code_required: "Coupon code is required",
    coupon_not_available: "Coupon code is unavailable",
    contact_email_registered: "Email already exists",
    invalidEmailFormat: "Invalid Email Format",
    emailRequired: "Email is required",
    paymentMethodRequired: "Please Choose Payment Method",
    depositMethodRequired: "Please Choose Deposit Method",
    no_changes: "Default Bank remain unchanged",
    resultIdRequired: "Result id required",
    free_credit_detected: "Deposit to play",

    //new
    amount_required: "Amount is required",
    auth_token_required: "Session token is required",
    bet_id_required: "Bet id is required",
    bonus_unavailable: "Bonus unavailable",
    client_ip_required: "Client ip required",
    first_deposit_not_met: "First Deposit required",
    ftd_required: "First Deposit required",
    game_maintenance: "Currenty under maintenance, please try again later",
    gateway_acc_required : "Gateway account required",
    inbox_id_required: "Inbox ID required",
    insufficient_rebate: "Insufficient rebate",
    insufficient_ticket: "Insufficient ticket",
    is_default_required: "default selection required",
    min_withdrawal_not_met: "Minimum withdrawal not met",
    newbie_not_met: "Newbie not met",
    no_changes: "Default Bank remain unchanged",
    promotion_not_available:"Promotion not available",
    ref_no_required: "Reference number required",
    result_id_required: "Result ID required",
    search_id_required: "Search ID required",
    setting_not_set: "Setting not configured",
    tac_required: "Tac code required",
    ticket_count_required: "Ticket amount required",
    vip_not_exists: "Not a VIP member",
    working_date_required: "Working date required",
    working_month_required: "Working month required",
    withdrawal_amount_lte_withhold_amount: "Withdrawal amount less than or equal to withhold amount.",
    providerRequired: "Provider required",
    invalid_contact_email: "Invalid Email",
    invalidUsernameFormat: "Invalid username format",
    secondaryAccountExists: "Secondary Account Exist",

    accountInactive: "Account Inactive",
    permissionDenied: "Permission Denied",
    amountRequired: "Amount Required",
    ipAddressRequired: "IP Address Required",
    transactionIdRequired: "Transaction ID required",
    parentIdRequired: "Parent ID required",
    auditByRequired: "Audit By required",
    systemTypeRequired: "System Type required",
    currencyRequired: "Currency required",
    loginIdRequired: "Login ID required",
    profileIdRequired: "Profile ID required",
    authTokenRequired: "Invalid Session Token",
    promotionIdRequired: "Promotion ID required",
    promotionNameRequired: "Promotion name required",
    minDepositRequired: "Minimum deposit required",
    transferIdRequired: "Transfer ID required",
    betIdRequired: "Bet ID required",
    accountExists: "Account Exist",
    invalidSystemType: "Invalid System Type",
    accountNotExists: "Account Does Not Exists",
    invalidStatus: "Invalid Status",
    samePassword: "New password cannot be same as old password",
    invalidAmount: "Invalid Amount",
    pendingResultInGame: "Pending Result in Game",
    invalidSession: "Invalid Session",
    promotionExists: "Promotion exists",
    promotionNotExists: "Promotion does not exist",
    currencyNotSupported: "Currency not supported",
    minimumDepositNotMeet: "Minimum Deposit not met",
    promotionInactive: "Promotion Inactive",
    unableToLaunchSlotGameAtTheMoment: "Unable to launch game at the moment, please try again later",
    "Game Is Disable": "Game Disabled",
    undefined: "Please check your connection and try again",
    invalidLogin: "Invalid username/ password",
    invalidToken: "Session expired. Please login again",
    rebateOngoing: "There is rebate ongoing.",
    technicalError: "Technical error. Please contact your administrator.",
    unknownError: "Technical error. Please contact your administrator.",
    tacNotExpired: "TAC code not yet expired. Please try again later.",
    contactPhoneRequired: "Contact phone number is required",
    invalidPhoneFormat: "Invalid phone format. Please try again later.",
    invalidAccountName: "Invalid Account Name",
    insufficientFund: "Insufficient Fund",
    invalidIDContact: "Reset Password failed."
  },

  newpw_required: "Please enter new password",
  newpw_notsame: "New password cannot be the same as current password",
  newpw_alphanumeric: "New password must be combination of alphabet and number",

  oldpw_required: "Please enter current password.",

  pw_notmatched: "Confirm password did not match with new password",

  forgot_password_success: "Password updated successfully!!",  
  add_bank_success: "New Bank Account added successfully!!",
  set_default_success: "Set As Default Successfully!!",
  update_success:"Updated Successfully",

  tac_tooltips: "TAC Code has been sent to your contact number.",
  tac_tooltips1: 'Click "Resend" to get new tac code',
  tac_countdown: "Resend again in {countdown}",

  bank_details_tooltips: "Your withdrawal transaction wil be rejected, if your Bank Account Name is diferent form your registered full name in test.",
  copy_clipboard: "Link copied",

  wrong_filetype: "Wrong Filetype",
  deposit_confirm: "Are you sure want to deposit?",
  deposit_cancel: "Deposit failed.",
  deposit_success: "Deposit successfully!",

  upload_cancel: "Attachment uploaded failed.",
  upload_success: "Attachment uploaded successfully!",
  upload_missing: "Attachment is missing!",

  password_success: "Password updated successfully!!",

  addbank_success: "Bank added successfully",
  addbank_cancel:"Bank add failed",

  withdraw_success: "Submit withdrawal ticket successfully",
  withdraw_cancel: "Submit withdrawal ticket failed",

  rebate_success: "Rebate claimed successfully",
  
  transfer_success: "Member transfer successfully",
  addmember_success: "New member registered successfully",

  refNoRequired: "No. Ref is required",
  attachmentPathRequired: "Attachment is required",
  disconnect: "Please check your connection and try again",

  insufficientBalance : "Insufficient Balance",
  insufficientFund: "Insufficient Fund",
  amountRequired: "Amount Required",
};
